// removed by extract-text-webpack-plugin
module.exports = {"SnippetCard__container":"SnippetCard__container---Oj7Vr","SnippetCard__snippet":"SnippetCard__snippet---2Pxu0"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/InstallSnippetCard/style.styl
// module id = 89IP
// module chunks = 89